import { Box, Button, Modal, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: "white",
  boxShadow: 24,
  p: 5,
  textAlign: "centre",
  borderRadius: "10px",
  boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
};

function SideNav() {
  const loc = useLocation();
  const navigate = useNavigate();
  const currentUrl = loc.pathname;
  const [openSettingDropDown, setOpenDropDown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleClickOutside = (event) => {
    const sidebar = document.getElementById("sidebar");
    const mobileBtn = document.getElementById("mobile_btn");
    const overlay = document.getElementById("sidebar-overlay");

    if (window.innerWidth <= 991.98) {
      if (
        sidebar &&
        mobileBtn &&
        !sidebar.contains(event.target) &&
        !mobileBtn.contains(event.target) &&
        (sidebar.style.marginLeft === "0px" || sidebar.style.marginLeft === "0")
      ) {
        sidebar.style.marginLeft = "-575px";
        if (overlay) {
          overlay.style.display = "none";
        }
      }
    }
  };
  // Reset sidebar position on window resize and handle click outside
  useEffect(() => {
    const handleResize = () => {
      const sidebar = document.getElementById("sidebar");
      const overlay = document.getElementById("sidebar-overlay");

      if (window.innerWidth >= 992) {
        // Desktop view - ensure sidebar is visible
        if (sidebar) {
          sidebar.style.marginLeft = "";
        }
        if (overlay) {
          overlay.style.display = "none";
        }
      } else {
        // Mobile view - ensure sidebar is hidden by default
        if (sidebar) {
          const currentMargin =
            sidebar.style.marginLeft ||
            window.getComputedStyle(sidebar).marginLeft;
          if (currentMargin !== "-575px" && currentMargin !== "-575px") {
            sidebar.style.marginLeft = "-575px";
          }
        }
        if (overlay) {
          overlay.style.display = "none";
        }
      }
    };

    // Set initial state
    handleResize();

    window.addEventListener("resize", handleResize);
    document.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    setIsLoggingOut(true);
    setTimeout(() => {
      setShowModal(false);
      localStorage.removeItem("ProviderEmail");
      localStorage.removeItem("ProviderName");
      localStorage.removeItem("ProviderToken");
      localStorage.removeItem("ProviderServicesListSelected");
      localStorage.removeItem("ProviderSetup");
      localStorage.removeItem("addService");
      setIsLoggingOut(false);
      navigate("/");
    }, 2000);
  };
  // console.log("currentURL", currentUrl);
  return (
    <>
      {/* Overlay for mobile sidebar */}
      <div
        className="sidebar-overlay"
        id="sidebar-overlay"
        style={{
          display: "none",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
        onClick={() => {
          const sidebar = document.getElementById("sidebar");
          const overlay = document.getElementById("sidebar-overlay");
          if (sidebar) {
            sidebar.style.marginLeft = "-575px";
          }
          if (overlay) {
            overlay.style.display = "none";
          }
        }}
      />
      <div className="sidebar" id="sidebar">
        <div
          className="sidebar-inner slimscroll"
          style={{ overflow: "scroll" }}
        >
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              <li
                className={`${currentUrl === "/dashboard" ? "active" : ""}`}
                // onClick={handleClickOutside}
              >
                <Link to={"/dashboard"}>
                  <i className="ti ti-layout-grid" />
                  <span>Dashboard</span>
                </Link>
              </li>
              <li
                className={`${
                  currentUrl === "/my-services" ||
                  currentUrl === "/my-services/service-detail/:id"
                    ? "active"
                    : ""
                }`}
              >
                <Link to={"/my-services"}>
                  <i className="ti ti-briefcase" />
                  <span>My Services</span>
                </Link>
              </li>
              <li className={`${currentUrl === "/my-areas" ? "active" : ""}`}>
                <Link to={"/my-areas"}>
                  <i className="ti ti-map-pin" />
                  <span>My Areas</span>
                </Link>
              </li>
              <li
                className={`${
                  currentUrl === "/update-working-hours-notice-period"
                    ? "active"
                    : ""
                }`}
              >
                <Link
                  to={"/update-working-hours-notice-period"}
                  // style={{
                  //   color:
                  //     currentUrl === "/update-working-hours-notice-period" &&
                  //     "rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1))",
                  // }}
                >
                  <i className="ti ti-clock" />
                  Working hours and Notice Period
                </Link>
              </li>
              <li
                className={`${
                  currentUrl === "/booking-list" ||
                  currentUrl === "/booking-list/booking-detail/:id"
                    ? "active"
                    : ""
                }`}
              >
                <Link to={"/booking-list"}>
                  <i className="ti ti-calendar-month" />
                  <span>Bookings </span>
                </Link>
              </li>
              <li
                className={`${
                  currentUrl === "/booking-calendar" ? "active" : ""
                }`}
              >
                <Link to={"/booking-calendar"}>
                  <i className="ti ti-calendar-month" />
                  <span>Calendar </span>
                </Link>
              </li>
              <li className={`${currentUrl === "/reviews" ? "active" : ""}`}>
                <Link to={"/reviews"}>
                  <i className="ti ti-star" />
                  <span>Reviews</span>
                </Link>
              </li>
              <li className={`${currentUrl === "/chat" ? "active" : ""}`}>
                <Link to={"/chat"}>
                  <i className="ti ti-messages" />
                  <span>Chat</span>
                </Link>
              </li>
              <li className={`${currentUrl === "/payments" ? "active" : ""}`}>
                <Link to="/payments">
                  <i className="ti ti-wallet" />
                  Payment
                </Link>
              </li>
              <li
              // className={`${
              //   currentUrl === "/reviews" ||
              //   currentUrl === "/account-setting" ||
              //   currentUrl === "/update-password" ||
              //   currentUrl === "/update-company-documents" ||
              //   currentUrl === "/update-working-hours-notice-period"
              //     ? "active"
              //     : ""
              // }`}
              >
                <a
                  className={`${
                    currentUrl === "/account-setting" ||
                    currentUrl === "/update-password" ||
                    currentUrl === "/update-company-documents" ||
                    currentUrl === "/update-working-hours-notice-period"
                      ? "active"
                      : ""
                  }`}
                  onClick={() => {
                    setOpenDropDown(!openSettingDropDown);
                  }}
                >
                  <i className="ti ti-settings" />
                  <span>Settings</span>
                  <span className="menu-arrow" />
                </a>
                {openSettingDropDown && (
                  <ul
                    style={{ display: openSettingDropDown ? "block" : "none" }}
                  >
                    {/* <li>
                      <Link>
                        <i className="ti ti-chevrons-right me-2" />
                        Appointments
                      </Link>
                    </li> */}
                    <li
                      className={`${
                        currentUrl === "/account-setting" ? "active" : ""
                      }`}
                    >
                      <Link
                        to={"/account-setting"}
                        style={{
                          color:
                            currentUrl === "/account-setting" &&
                            "rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1))",
                        }}
                      >
                        <i className="ti ti-chevrons-right me-2" />
                        Edit Profile
                      </Link>
                    </li>
                    <li
                      className={`${
                        currentUrl === "/update-password" ? "active" : ""
                      }`}
                    >
                      <Link
                        to={"/update-password"}
                        style={{
                          color:
                            currentUrl === "/update-password" &&
                            "rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1))",
                        }}
                      >
                        <i className="ti ti-chevrons-right me-2" />
                        Change Password
                      </Link>
                    </li>
                    <li
                      className={`${
                        currentUrl === "/update-company-documents"
                          ? "active"
                          : ""
                      }`}
                    >
                      <Link
                        to={"/update-company-documents"}
                        style={{
                          color:
                            currentUrl === "/update-company-documents" &&
                            "rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1))",
                        }}
                      >
                        <i className="ti ti-chevrons-right me-2" />
                        Update Company Documents/Certifications
                      </Link>
                    </li>

                    {/* <li>
                      <Link href="provider-security-settings.html">
                        <i className="ti ti-chevrons-right me-2" />
                        Security
                      </Link>
                    </li>
                    <li>
                      <Link href="payment-settings.html">
                        <i className="ti ti-chevrons-right me-2" />
                        Payment
                      </Link>
                    </li>
                    <li>
                      <Link href="provider-notifcations.html">
                        <i className="ti ti-chevrons-right me-2" />
                        Notifications
                      </Link>
                    </li>
                    <li>
                      <Link href="verification.html">
                        <i className="ti ti-chevrons-right me-2" />
                        Profile Verification
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#del-account"
                      >
                        <i className="ti ti-chevrons-right me-2" />
                        Delete Account
                      </Link>
                    </li> */}
                  </ul>
                )}
              </li>

              {/*
              <li>
                <Link href="provider-booking-calendar.html">
                  <i className="ti ti-calendar" />
                  <span>Calendar </span>
                </Link>
              </li>
              <li>
                <Link href="customer-list.html">
                  <i className="ti ti-user" />
                  <span>Customers</span>
                </Link>
              </li>
              <li>
                <Link href="provider-payout.html">
                  <i className="ti ti-wallet" />
                  <span>Payout</span>
                </Link>
              </li>
              
              <li>
                <Link href="provider-enquiry.html">
                  <i className="ti ti-mail" />
                  <span>Enquiries</span>
                </Link>
              </li>
              <li>
                <Link href="provider-earnings.html">
                  <i className="ti ti-cash-banknote" />
                  <span>Earnings</span>
                </Link>
              </li>
              
              <li className="submenu">
                <Link href="javascript:void(0);">
                  <i className="ti ti-settings" />
                  <span>Settings</span>
                  <span className="menu-arrow" />
                </Link>
                <ul>
                  <li>
                    <Link href="provider-appointment-settings.html">
                      <i className="ti ti-chevrons-right me-2" />
                      Appointments
                    </Link>
                  </li>
                  <li>
                    <Link href="provider-accounts-settings.html">
                      <i className="ti ti-chevrons-right me-2" />
                      Account
                    </Link>
                  </li>
                  <li>
                    <Link href="provider-security-settings.html">
                      <i className="ti ti-chevrons-right me-2" />
                      Security
                    </Link>
                  </li>
                  <li>
                    <Link href="payment-settings.html">
                      <i className="ti ti-chevrons-right me-2" />
                      Payment
                    </Link>
                  </li>
                  <li>
                    <Link href="provider-notifcations.html">
                      <i className="ti ti-chevrons-right me-2" />
                      Notifications
                    </Link>
                  </li>
                  <li>
                    <Link href="verification.html">
                      <i className="ti ti-chevrons-right me-2" />
                      Profile Verification
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#del-account"
                    >
                      <i className="ti ti-chevrons-right me-2" />
                      Delete Account
                    </Link>
                  </li>
                </ul>
              </li> */}
              <li>
                <a onClick={() => setShowModal(true)}>
                  <i className="ti ti-logout-2" />
                  <span>Logout</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Modal open={showModal}>
        <Box style={style}>
          <Box
            sx={{
              margin: "20px",
              display: "flex",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            {/* <div className="modal-header"> */}
            <h5 className="modal-title">Are you sure you want to logout?</h5>
            {/* <button
              type="button"
              className="btn-close"
              onClick={() => setShowDeleteModal(false)}
            /> */}
            {/* </div> */}
          </Box>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "end",
              gap: 7,
              margin: "20px",
            }}
          >
            <button
              disabled={isLoggingOut}
              className="btn btn-secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
            <button
              disabled={isLoggingOut}
              className="btn btn-danger"
              onClick={handleLogout}
            >
              {isLoggingOut ? "Logging Out..." : "Logout"}
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default SideNav;
